const referralCoupon = {
    isLoading: {
        list: false,
    },
    list: {},
    listDisplay: [],
    listParams: {
        filters: {},
        activePage: 1,
        perPage: 24,
        totalRecords: 1,
        sortBy: '',
        sortDirection: '',
    },
    filterForm: {
        // selectedCategory: '',
    },
    selected: {},
    allCheckboxesSelected: false,
};
const ReferralCouponReducer = function(state = referralCoupon, action) {
    switch (action.type) {
        case 'TOGGLE_REFERRAL_COUPON_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: action.value,
                },
            };
        }
        case 'UPDATE_REFERRAL_COUPON_LIST': {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...action.value,
                },
            };
        }
        case 'UPDATE_REFERRAL_COUPON_LIST_DISPLAY': {
            return {
                ...state,
                listDisplay: action.value,
            };
        }
        case 'REPLACE_REFERRAL_COUPON_SELECTED_ROWS': {
            return {
                ...state,
                selected: action.value,
            };
        }
        case 'UPDATE_REFERRAL_COUPON_SELECTED_ROW': {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [action.key]: action.value,
                },
            };
        }
        case 'RESET_REFERRAL_COUPON_SELECTED_ROWS': {
            return {
                ...state,
                selected: {},
            };
        }
        case 'UPDATE_REFERRAL_COUPON_ALL_ROWS_CHECKBOX': {
            return {
                ...state,
                allCheckboxesSelected: action.value,
            };
        }
        case 'UPDATE_REFERRAL_COUPON_LIST_FILTERS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    filters: action.value,
                },
            };
        }
        case 'SET_REFERRAL_COUPON_LIST_SORT': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    sortBy: action.value,
                    sortDirection: action.direction,
                },
            };
        }
        case 'SET_REFERRAL_COUPON_LIST_ACTIVE_PAGE': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    activePage: action.value,
                },
            };
        }
        case 'SET_REFERRAL_COUPON_LIST_TOTAL_RECORDS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    totalRecords: action.value,
                },
            };
        }
        case 'UPDATE_REFERRAL_COUPON_FILTER_FORM_DATA': {
            return {
                ...state,
                filterForm: {
                    ...state.filterForm,
                    [action.key]: action.value,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default ReferralCouponReducer;
